import { Injectable } from "@angular/core";
import {
	DefaultTranspiler,
	TranspileParams,
	getValue,
	isDefined,
	isString,
} from "@jsverse/transloco";

@Injectable()
export class SinglePassTranspiler extends DefaultTranspiler {
	override transpile(transpileParams: TranspileParams): unknown {
		const { value, params = {}, translation } = transpileParams;
		if (!isString(value)) return super.transpile(transpileParams);

		return value.replace(this.interpolationMatcher, (_match, name: string) => {
			const paramName = name.trim();
			const param = getValue(params, paramName);
			if (isDefined(param)) return String(param);
			const reference = translation[paramName];
			return isDefined(reference)
				? String(super.transpile({ ...transpileParams, value: reference }))
				: "";
		});
	}
}
